import LoaderButton from '@/src/components/Commons/LoaderButton/LoaderButton';
import { InvestUnitEntity, InvestUnitWithDetailsEntity } from '@/src/lib/MayzSmartDB/Entities/index';
import TokenLogo from '../../TokenLogoWithCircle/TokenLogoWithCircle';
import styles from './InvestUnitSmall.module.scss';
import useInvestUnitSmall from './useInvestUnitSmall';

export default function InvestUnitSmall({ investUnit, investUnitWithDetails }: { investUnit?: InvestUnitEntity; investUnitWithDetails?: InvestUnitWithDetailsEntity }) {
    //--------------------------------------
    const { isRefreshing, isTokensStoreLoading, tokensMetadata } = useInvestUnitSmall({ investUnit, investUnitWithDetails });
    //--------------------------------------
    return (
        <>
            {/* {toJson(tokensStore.tokens, 4)} */}

            {investUnit !== undefined || investUnitWithDetails !== undefined ? (
                <>
                    <div className={styles.tokens}>
                        {isTokensStoreLoading ? (
                            <LoaderButton />
                        ) : (
                            tokensMetadata.map((token) => (
                                <TokenLogo key={token.CS + token.TN_Hex} token={token} showBorder={false} className={styles.tokenLogo} width={20} height={20} />
                            ))
                        )}
                    </div>
                </>
            ) : null}
        </>
    );
    //--------------------------------------
}
